/* CUSTOMIZATIONS
  - rimosso il bg-primary se manca l'immagine o il video
*/

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Pluggable } from '@plone/volto/components/manage/Pluggable';
import { flattenToAppURL } from '@plone/volto/helpers';
import config from '@plone/volto/registry';

/**
 * LeadImage component class.
 * @class Header
 * @extends Component
 */
const LeadImage = () => {
  const content = useSelector((state) => state.content.data);
  const location = useLocation();
  const leadConfig = config.settings.iovisit.leadimage;
  const SmallHeaderFor = leadConfig.sizeSmall.contentTypes ?? [];
  const NoLeadImageFor = leadConfig.hideFor ?? [];

  // We allow settings.nonContentRoutes to have strings (that are supposed to match
  // ending strings of pathnames, so we are converting them to RegEx to match also
  const normalizedNonContentRoutes = config.settings.nonContentRoutes.map(
    (item) => {
      if (item.test) {
        return item;
      } else {
        return new RegExp(item + '$');
      }
    },
  );

  const isNonContentRoutes = normalizedNonContentRoutes.some((rx) =>
    rx.test(location.pathname),
  );

  if (content && !isNonContentRoutes) {
    const contentType = content['@type'];

    const image = content?.image?.scales?.leadimage;
    const videoUrl = content?.video?.download;
    const videoMimeType = content?.video?.['content-type'];

    if (NoLeadImageFor.indexOf(contentType) >= 0) {
      return null;
    }

    let size = 'default';
    if (SmallHeaderFor.indexOf(contentType) > 0) {
      size = 'small';
    }

    let description = content.image_caption;

    return (
      <>
        {image || videoUrl ? (
          <>
            <div
              className={`leadimage ${
                videoUrl ? 'leadvideo' : ''
              } size-${size}`}
            >
              {videoUrl ? (
                <video
                  loop={true}
                  muted={true}
                  autoPlay={true}
                  poster={
                    image?.download ? flattenToAppURL(image.download) : null
                  }
                >
                  <source
                    type={videoMimeType}
                    src={flattenToAppURL(videoUrl)}
                  />
                </video>
              ) : (
                <img
                  src={flattenToAppURL(image.download)}
                  alt={content?.title ?? ''}
                  loading="lazy"
                />
              )}
              <div className="leadimage-more">
                <Pluggable
                  name="leadimage-more"
                  params={{ content: content }}
                />
              </div>
            </div>
            {description && (
              <div className="lead-caption caption">{description}</div>
            )}
          </>
        ) : (
          <div className="leadimage space"></div>
        )}
      </>
    );
  }

  return (
    <Pluggable name="leadimage">
      {(pluggables) =>
        pluggables.map((p, i) => (
          <div className="leadimage" key={i}>
            {p()}
          </div>
        ))
      }
    </Pluggable>
  );
};

export default LeadImage;
